'use client'

import classNames from 'classnames'
import React from 'react'

import { ReactComponent as ArrowRight } from '~/assets/icons/arrow-right.svg'

interface Props {
  pagination?: string
  isBackDisable?: boolean
  isNextDisable?: boolean
  onClickBack?: () => void
  onClickNext?: () => void
  hidden?: boolean
  defaultSpacing?: boolean
}

const SliderNavigation: React.FC<Props> = ({
  pagination,
  onClickBack,
  onClickNext,
  isBackDisable,
  isNextDisable,
  hidden,
  defaultSpacing = true,
}) => {
  return (
    <div
      className={classNames('flex items-center gap-4', {
        'justify-center w-full mt-4': defaultSpacing,
      })}
    >
      <button
        className={classNames(
          'w-6 h-6 flex items-center justify-center text-current hover:text-red-500',
          {
            'opacity-30': isBackDisable,
          }
        )}
        onClick={onClickBack}
        disabled={isBackDisable}
        aria-label="Anterior"
        tabIndex={hidden ? -1 : undefined}
      >
        <ArrowRight className="rotate-180" />
      </button>
      {pagination && (
        <div
          className={classNames(
            pagination,
            'flex justify-center gap-4 !w-auto'
          )}
        />
      )}
      <button
        className={classNames(
          'w-6 h-6 flex items-center justify-center text-current hover:text-red-500',
          {
            'opacity-30': isNextDisable,
          }
        )}
        onClick={onClickNext}
        disabled={isNextDisable}
        aria-label="Proximo"
        tabIndex={hidden ? -1 : undefined}
      >
        <ArrowRight />
      </button>
    </div>
  )
}

export default SliderNavigation
